export enum Service {
    CUSTOMIZATION = "CUSTOMIZATION",
    GARMENT_WASH_AND_CLEAN = "GARMENT_WASH_AND_CLEAN",
    ALTERATION = "ALTERATION"
}